<template>
  <div class="access-control-container">
    <el-row :gutter="20">
      <el-col :span="4">
        <el-card class="community-selector">
          <div class="community-list">
            <li
              v-for="item in communityList"
              :key="item.communityId"
              :class="['community-item', { selected: searchForm.communityId === item.communityId }]"
              @click="handleCommunityClick(item)">
              {{ item.name }}
            </li>
          </div>
        </el-card>
      </el-col>
      <el-col :span="20">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick">
          <!-- 设备管理 Tab -->
          <el-tab-pane label="设备管理" name="machine">
            <el-card class="box-card">
              <div slot="header" class="clearfix flex justify-between">
                <span>查询条件</span>
              </div>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-input v-model="searchForm.machineName" placeholder="请输入设备名称" clearable />
                </el-col>
                <el-col :span="6">
                  <el-button type="primary" @click="handleSearch">搜索</el-button>
                </el-col>
              </el-row>
            </el-card>
            <el-card class="box-card" style="margin-top: 20px;">
              <div slot="header" class="clearfix flex justify-between">
                <span>门禁信息</span>
                <el-button type="primary" size="small" @click="handleAdd">添加设备</el-button>
              </div>
              <el-table v-loading="loading" :data="tableData" border style="width: 100%">
                <el-table-column prop="machineName" label="设备名称" align="center" />
                <el-table-column prop="mqttDeviceId" label="MQTT设备SN" align="center" />
                <el-table-column prop="direction" label="方向" align="center" width="80">
                  <template slot-scope="scope">
                    {{ scope.row.direction === '3306' ? '进' : '出' }}
                  </template>
                </el-table-column>
                <el-table-column label="位置" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.floorNum || '' }}{{ scope.row.unitNum ? '-' + scope.row.unitNum : '' }}
                  </template>
                </el-table-column>
                <el-table-column prop="mqttState" label="MQTT状态" align="center" width="100">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.mqttState === '1200'" type="success" size="small">在线</el-tag>
                    <el-tag v-else-if="scope.row.mqttState === '1300'" type="danger" size="small">离线</el-tag>
                    <el-tag v-else type="info" size="small">未知</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="mqttHeartbeatTime" label="最后心跳" align="center" width="160">
                  <template slot-scope="scope">
                    {{ scope.row.mqttHeartbeatTime || '-' }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="320">
                  <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" @click="handleDetail(scope.row)">详情</el-button>
                    <el-button size="mini" type="warning" :disabled="scope.row.mqttState !== '1200'" @click="handleRemoteOpen(scope.row)">远程开门</el-button>
                    <el-button size="mini" type="success" @click="handleSyncAuth(scope.row)">同步授权</el-button>
                    <el-button size="mini" type="danger" @click="handleDeleteMachine(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination :current-page.sync="pagination.current" :page-sizes="[10, 20, 30, 50]"
                :page-size="pagination.size" :total="pagination.total" layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </el-card>
          </el-tab-pane>

          <!-- 授权管理 Tab -->
          <el-tab-pane label="授权管理" name="auth">
            <el-card class="box-card">
              <div slot="header" class="clearfix flex justify-between">
                <span>授权列表</span>
              </div>
              <el-row :gutter="20" style="margin-bottom: 15px;">
                <el-col :span="4">
                  <el-select v-model="authFilter.personType" placeholder="人员类型" clearable style="width: 100%" @change="loadAuthList">
                    <el-option label="全部" value="" />
                    <el-option label="业主" value="1002" />
                    <el-option label="员工" value="1001" />
                  </el-select>
                </el-col>
                <el-col :span="4">
                  <el-select v-model="authFilter.state" placeholder="状态" clearable style="width: 100%" @change="loadAuthList">
                    <el-option label="全部" value="" />
                    <el-option label="通过" value="10301" />
                    <el-option label="未通过" value="10302" />
                    <el-option label="待审核" value="1030" />
                  </el-select>
                </el-col>
                <el-col :span="4">
                  <el-button type="primary" size="small" @click="handleAddAuth">新增授权</el-button>
                </el-col>
              </el-row>
              <el-alert
                title="授权说明：业主自动按房屋区域匹配对应门禁设备（单元门→对应单元业主，楼栋门→对应楼栋业主，大门→全部业主）；员工自动授权所有门禁设备。"
                type="info"
                :closable="false"
                show-icon
                style="margin-bottom: 15px;" />
              <el-table v-loading="authLoading" :data="authData" border style="width: 100%">
                <el-table-column prop="personName" label="姓名" align="center" />
                <el-table-column prop="machineName" label="设备名称" align="center" />
                <el-table-column prop="personType" label="人员类型" align="center" width="100">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.personType === '1001'" size="small">员工</el-tag>
                    <el-tag v-else-if="scope.row.personType === '1002'" type="warning" size="small">业主</el-tag>
                    <el-tag v-else size="small">{{ scope.row.personType }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="state" label="状态" align="center" width="100">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.state === '10301'" type="success" size="small">通过</el-tag>
                    <el-tag v-else-if="scope.row.state === '10302'" type="danger" size="small">未通过</el-tag>
                    <el-tag v-else type="warning" size="small">待审核</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="startTime" label="开始时间" align="center" width="160" />
                <el-table-column prop="endTime" label="结束时间" align="center" width="160" />
                <el-table-column label="操作" align="center" width="160">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.state === '10302'" size="mini" type="warning" @click="handleResendAuth(scope.row)">重新下发</el-button>
                    <el-button size="mini" type="danger" @click="handleDeleteAuth(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination :current-page.sync="authPagination.current" :page-sizes="[10, 20, 50]"
                :page-size="authPagination.size" :total="authPagination.total" layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleAuthSizeChange" @current-change="handleAuthCurrentChange" />
            </el-card>
          </el-tab-pane>

          <!-- 时段管理 Tab -->
          <el-tab-pane label="时段管理" name="time">
            <el-card class="box-card">
              <div slot="header" class="clearfix flex justify-between">
                <span>门禁开放时段</span>
                <el-button type="primary" size="small" @click="handleSaveTime">保存配置</el-button>
              </div>
              <el-row :gutter="20" style="margin-bottom: 15px;">
                <el-col :span="6">
                  <el-select v-model="timeMachineId" placeholder="选择设备" clearable style="width: 100%" @change="handleTimeMachineChange">
                    <el-option label="全局默认" value="-1" />
                    <el-option v-for="item in machineOptions" :key="item.machineId" :label="item.machineName"
                      :value="item.machineId" />
                  </el-select>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6" v-for="item in timeSlots" :key="item.hours" style="margin-bottom: 8px;">
                  <div :class="['time-slot-card', { 'is-open': item.isOpen === 'Y' }]" @click="toggleTimeSlot(item)">
                    <span class="hours">{{ item.hours }}</span>
                    <el-tag :type="item.isOpen === 'Y' ? 'success' : 'info'" size="mini">
                      {{ item.isOpen === 'Y' ? '开放' : '关闭' }}
                    </el-tag>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

    <!-- 添加/编辑设备对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="handleDialogClose">
      <el-form ref="machineForm" :model="formData" :rules="formRules" label-width="120px">
        <el-form-item label="设备名称" prop="machineName">
          <el-input v-model="formData.machineName" placeholder="请输入设备名称" />
        </el-form-item>
        <el-form-item label="MQTT设备SN" prop="mqttDeviceId">
          <el-input v-model="formData.mqttDeviceId" placeholder="请输入设备SN号" />
        </el-form-item>
        <el-form-item label="设备方向" prop="direction">
          <el-select v-model="formData.direction" placeholder="请选择设备方向" style="width: 100%">
            <el-option label="进" value="3306" />
            <el-option label="出" value="3307" />
          </el-select>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="安装位置">
              <el-select v-model="formData.floorId" placeholder="不选则默认为小区大门"
                style="width: 100%" @change="handleFloorChange" clearable>
                <el-option v-for="item in floorOptions" :key="item.floorId" :label="item.floorName"
                  :value="item.floorId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单元">
              <el-select v-model="formData.unitId" placeholder="请选择单元（可选）"
                style="width: 100%" clearable :disabled="!formData.floorId">
                <el-option v-for="item in unitOptions" :key="item.unitId" :label="item.unitNum"
                  :value="item.unitId" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="授权人员类型">
          <el-checkbox-group v-model="formData.authPersonTypes">
            <el-checkbox label="1001">员工</el-checkbox>
            <el-checkbox label="1002">业主</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>

    <!-- 设备详情对话框 -->
    <el-dialog title="设备详情" :visible.sync="detailVisible" width="500px">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="设备名称">{{ detailData.machineName }}</el-descriptions-item>
        <el-descriptions-item label="MQTT设备SN">{{ detailData.mqttDeviceId }}</el-descriptions-item>
        <el-descriptions-item label="设备方向">{{ detailData.direction === '3306' ? '进' : '出' }}</el-descriptions-item>
        <el-descriptions-item label="小区">{{ detailData.communityName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="楼栋">{{ detailData.floorNum || '-' }}</el-descriptions-item>
        <el-descriptions-item label="单元">{{ detailData.unitNum || '-' }}</el-descriptions-item>
        <el-descriptions-item label="MQTT状态">
          <el-tag v-if="detailData.mqttState === '1200'" type="success" size="small">在线</el-tag>
          <el-tag v-else-if="detailData.mqttState === '1300'" type="danger" size="small">离线</el-tag>
          <el-tag v-else type="info" size="small">未知</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="最后心跳">{{ detailData.mqttHeartbeatTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="设备IP">{{ detailData.machineIp || '-' }}</el-descriptions-item>
        <el-descriptions-item label="设备MAC">{{ detailData.machineMac || '-' }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 新增授权对话框 -->
    <el-dialog title="新增授权" :visible.sync="authDialogVisible" width="500px">
      <el-form ref="authForm" :model="authFormData" label-width="120px">
        <el-form-item label="设备" prop="machineId" :rules="[{ required: true, message: '请选择设备', trigger: 'change' }]">
          <el-select v-model="authFormData.machineId" placeholder="请选择设备" style="width: 100%" filterable>
            <el-option v-for="item in machineOptions" :key="item.machineId" :label="item.machineName" :value="item.machineId" />
          </el-select>
        </el-form-item>
        <el-form-item label="人员类型" prop="personType">
          <el-select v-model="authFormData.personType" style="width: 100%" @change="handlePersonTypeChange">
            <el-option label="业主" value="1002" />
            <el-option label="员工" value="1001" />
          </el-select>
        </el-form-item>
        <el-form-item label="选择人员" prop="personId" :rules="[{ required: true, message: '请选择人员', trigger: 'change' }]">
          <el-select
            v-model="authFormData.personId"
            placeholder="请搜索人员姓名"
            style="width: 100%"
            filterable
            remote
            :remote-method="searchPerson"
            :loading="personSearchLoading"
            @change="handlePersonSelect"
          >
            <el-option
              v-for="item in personOptions"
              :key="item.personId"
              :label="item.personName + (item.tel ? ' (' + item.tel + ')' : '')"
              :value="item.personId"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="authDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmitAuth">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listAccessControl, listMachineAuth, deleteMachineAuth, listAccessControlTime, saveAccessControlTime, saveMachine, updateMachine, saveMachineAuth, remoteOpenDoor, deleteMachine, syncMachineAuth } from '@/api/property/accessControlApi'
import { queryFloors, queryUnits } from '@/api/room/addRoomViewApi'
import { queryOwners } from '@/api/owner/ownerApi'
import { queryStaffInfos } from '@/api/staff/staffApi'

export default {
  name: 'PropertyAccessControlList',
  data() {
    return {
      activeTab: 'machine',
      loading: false,
      submitLoading: false,
      communityList: [],
      searchForm: {
        machineName: '',
        communityId: ''
      },
      tableData: [],
      machineOptions: [],
      pagination: { current: 1, size: 10, total: 0 },
      // 设备表单
      dialogVisible: false,
      isEdit: false,
      editMachineId: '',
      detailVisible: false,
      detailData: {},
      formData: { machineName: '', mqttDeviceId: '', direction: '3306', floorId: '', unitId: '', authPersonTypes: ['1001', '1002'] },
      formRules: {
        machineName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        mqttDeviceId: [{ required: true, message: '请输入MQTT设备SN', trigger: 'blur' }],
        direction: [{ required: true, message: '请选择设备方向', trigger: 'change' }]
      },
      floorOptions: [],
      unitOptions: [],
      // 授权管理
      authLoading: false,
      authData: [],
      authFilter: { personType: '', state: '' },
      authPagination: { current: 1, size: 10, total: 0 },
      // 时段管理
      timeMachineId: '-1',
      timeSlots: [],
      // 新增授权
      authDialogVisible: false,
      authFormData: { machineId: '', personId: '', personName: '', personType: '1002', communityId: '' },
      personSearchLoading: false,
      personOptions: []
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑设备' : '添加设备'
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      try {
        this.loading = true
        const params = { ...this.searchForm, page: this.pagination.current, row: this.pagination.size }
        const { data, total, communitys } = await listAccessControl(params)
        if (communitys.length > 0 && this.communityList.length === 0) {
          this.communityList = communitys
          if (!this.searchForm.communityId) {
            this.searchForm.communityId = communitys[0].communityId
            const { data: newData, total: newTotal } = await listAccessControl({
              ...this.searchForm, page: 1, row: this.pagination.size
            })
            this.tableData = newData
            this.pagination.total = newTotal
            this.machineOptions = newData
            return
          }
        }
        this.tableData = data
        this.pagination.total = total
        this.machineOptions = data
      } catch (error) {
        this.$message.error('获取设备列表失败')
      } finally {
        this.loading = false
      }
    },
    handleCommunityClick(community) {
      this.searchForm.communityId = community.communityId
      this.handleSearch()
    },
    handleSearch() {
      this.pagination.current = 1
      this.getList()
    },
    handleSizeChange(val) { this.pagination.size = val; this.getList() },
    handleCurrentChange(val) { this.pagination.current = val; this.getList() },
    handleTabClick(tab) {
      if (tab.name === 'auth') {
        this.loadAuthList()
      } else if (tab.name === 'time') {
        this.loadTimeSlots()
      }
    },
    // ===== 授权管理 =====
    async loadAuthList() {
      try {
        this.authLoading = true
        const params = {
          communityId: this.searchForm.communityId,
          personType: this.authFilter.personType,
          state: this.authFilter.state,
          page: this.authPagination.current,
          row: this.authPagination.size
        }
        const { data, total } = await listMachineAuth(params)
        this.authData = data
        this.authPagination.total = total
      } catch (error) {
        this.$message.error('获取授权列表失败')
      } finally {
        this.authLoading = false
      }
    },
    handleAuthSizeChange(val) { this.authPagination.size = val; this.loadAuthList() },
    handleAuthCurrentChange(val) { this.authPagination.current = val; this.loadAuthList() },
    handleDeleteAuth(row) {
      this.$confirm('确定要删除该授权吗？', '提示', { type: 'warning' }).then(async () => {
        try {
          await deleteMachineAuth({ authId: row.authId, bId: row.bId })
          this.$message.success('删除成功')
          this.loadAuthList()
        } catch (error) {
          this.$message.error(error.message || '删除失败')
        }
      }).catch(() => {})
    },
    handleAddAuth() {
      if (!this.searchForm.communityId) { this.$message.warning('请先选择小区'); return }
      this.authFormData = { machineId: '', personId: '', personName: '', personType: '1002', communityId: this.searchForm.communityId }
      this.personOptions = []
      this.authDialogVisible = true
    },
    handlePersonTypeChange() {
      this.authFormData.personId = ''
      this.authFormData.personName = ''
      this.personOptions = []
    },
    async searchPerson(query) {
      if (!query || query.length < 1) { this.personOptions = []; return }
      this.personSearchLoading = true
      try {
        if (this.authFormData.personType === '1002') {
          // 查询业主
          const res = await queryOwners({ communityId: this.authFormData.communityId, name: query, page: 1, row: 20 })
          const owners = res.owners || res.data || []
          this.personOptions = owners.map(o => ({ personId: o.memberId, personName: o.name, tel: o.link || o.tel }))
        } else {
          // 查询员工
          const res = await queryStaffInfos({ staffName: query, page: 1, row: 20 })
          const staffs = res.staffs || res.data || []
          this.personOptions = staffs.map(s => ({ personId: s.userId, personName: s.name, tel: s.tel }))
        }
      } catch (error) {
        this.personOptions = []
      } finally {
        this.personSearchLoading = false
      }
    },
    handlePersonSelect(personId) {
      const selected = this.personOptions.find(p => p.personId === personId)
      if (selected) {
        this.authFormData.personName = selected.personName
      }
    },
    async handleSubmitAuth() {
      this.$refs.authForm.validate(async (valid) => {
        if (!valid) return
        try {
          await saveMachineAuth(this.authFormData)
          this.$message.success('授权成功')
          this.authDialogVisible = false
          this.loadAuthList()
        } catch (error) {
          this.$message.error(error.message || '授权失败')
        }
      })
    },
    handleResendAuth(row) {
      this.$confirm('确定要重新下发达个人脸吗？', '提示', { type: 'warning' }).then(async () => {
        try {
          await saveMachineAuth({
            machineId: row.machineId,
            personId: row.personId,
            personName: row.personName,
            personType: row.personType,
            communityId: row.communityId
          })
          this.$message.success('已重新下发')
          this.loadAuthList()
        } catch (error) {
          this.$message.error(error.message || '重新下发失败')
        }
      }).catch(() => {})
    },
    // ===== 时段管理 =====
    async loadTimeSlots() {
      try {
        const res = await listAccessControlTime({ machineId: this.timeMachineId, communityId: this.searchForm.communityId })
        this.timeSlots = res.timeSlots || []
      } catch (error) {
        this.$message.error('获取时段配置失败')
      }
    },
    handleTimeMachineChange() {
      this.loadTimeSlots()
    },
    toggleTimeSlot(item) {
      item.isOpen = item.isOpen === 'Y' ? 'N' : 'Y'
    },
    async handleSaveTime() {
      try {
        await saveAccessControlTime({ machineId: this.timeMachineId, timeSlots: this.timeSlots })
        this.$message.success('保存成功')
      } catch (error) {
        this.$message.error(error.message || '保存失败')
      }
    },
    // ===== 设备增删改 =====
    handleDetail(row) { this.detailData = row; this.detailVisible = true },
    handleRemoteOpen(row) {
      this.$confirm('确定要远程开门吗？设备：' + row.machineName, '远程开门', { type: 'warning' }).then(async () => {
        try {
          await remoteOpenDoor({ machineId: row.machineId, communityId: this.searchForm.communityId })
          this.$message.success('开门指令已发送')
        } catch (error) {
          this.$message.error(error.message || '远程开门失败')
        }
      }).catch(() => {})
    },
    handleSyncAuth(row) {
      this.$confirm('确定要同步该设备的授权人员吗？将根据设备位置和人员类型配置重新同步业主和员工人脸。', '同步授权', { type: 'info' }).then(async () => {
        try {
          const res = await syncMachineAuth({ machineId: row.machineId, communityId: this.searchForm.communityId })
          const data = res.data || {}
          this.$message.success('同步完成：业主' + (data.syncOwnerCount || 0) + '人，员工' + (data.syncStaffCount || 0) + '人')
        } catch (error) {
          this.$message.error(error.message || '同步授权失败')
        }
      }).catch(() => {})
    },
    handleDeleteMachine(row) {
      this.$confirm('确定要删除设备"' + row.machineName + '"吗？如果该设备有授权人员，需先删除所有授权。', '删除设备', { type: 'warning' }).then(async () => {
        try {
          await deleteMachine({ machineId: row.machineId, communityId: this.searchForm.communityId })
          this.$message.success('删除成功')
          this.getList()
        } catch (error) {
          this.$message.error(error.message || '删除失败')
        }
      }).catch(() => {})
    },
    handleAdd() {
      if (!this.searchForm.communityId) { this.$message.warning('请先选择小区'); return }
      this.isEdit = false; this.editMachineId = ''
      this.formData = { machineName: '', mqttDeviceId: '', direction: '3306', floorId: '', unitId: '', authPersonTypes: [] }
      this.unitOptions = []; this.loadFloors(); this.dialogVisible = true
    },
    async handleEdit(row) {
      this.isEdit = true; this.editMachineId = row.machineId
      const selectedFloorId = row.locationTypeCd || ''
      let selectedUnitId = row.locationObjId || ''
      if (selectedUnitId === selectedFloorId) selectedUnitId = ''
      await this.loadFloorsForEdit(selectedFloorId)
      // authPersonTypes 兼容数组和逗号分隔字符串
      let personTypes = ['1001', '1002']
      if (row.authPersonTypes) {
        personTypes = Array.isArray(row.authPersonTypes) ? [...row.authPersonTypes] : row.authPersonTypes.split(',').filter(t => t)
      }
      this.formData = { machineName: row.machineName || '', mqttDeviceId: row.mqttDeviceId || '', direction: row.direction || '3306', floorId: selectedFloorId, unitId: selectedUnitId, authPersonTypes: personTypes }
      this.dialogVisible = true
    },
    async loadFloors() {
      if (!this.searchForm.communityId) return
      try {
        const res = await queryFloors({ communityId: this.searchForm.communityId, page: 1, row: 300 })
        const floorData = res.apiFloorDataVoList || (res.data && res.data.apiFloorDataVoList) || []
        this.floorOptions = floorData.filter(f => f.floorNum !== '0')
      } catch (error) { this.floorOptions = [] }
    },
    async loadFloorsForEdit(selectedFloorId) {
      await this.loadFloors()
      if (selectedFloorId) await this.handleFloorChange(selectedFloorId)
    },
    async handleFloorChange(floorId) {
      this.formData.unitId = ''; this.unitOptions = []
      if (!floorId) return
      try {
        const res = await queryUnits({ communityId: this.searchForm.communityId, floorId: floorId, page: 1, row: 300 })
        const units = res.data || res || []
        this.unitOptions = Array.isArray(units) ? units.filter(u => u.unitNum !== '0') : []
      } catch (error) { this.unitOptions = [] }
    },
    handleDialogClose() { this.$refs.machineForm && this.$refs.machineForm.resetFields() },
    async handleSubmit() {
      this.$refs.machineForm.validate(async (valid) => {
        if (!valid) return
        try {
          this.submitLoading = true
          const locationTypeCd = this.formData.unitId || this.formData.floorId
          const data = {
            machineName: this.formData.machineName, machineCode: this.formData.mqttDeviceId, mqttDeviceId: this.formData.mqttDeviceId,
            direction: this.formData.direction, locationTypeCd, floorId: this.formData.floorId, unitId: this.formData.unitId,
            machineTypeCd: '9999', typeId: '9999', communityId: this.searchForm.communityId,
            machineVersion: 'v300', authCode: 'nanyi_default', mqttState: '1300',
            authPersonTypes: this.formData.authPersonTypes || ['1001', '1002']
          }
          if (this.isEdit) {
            data.machineId = this.editMachineId; await updateMachine(data); this.$message.success('更新成功')
          } else {
            await saveMachine(data); this.$message.success('添加成功')
          }
          this.dialogVisible = false; this.getList()
        } catch (error) { this.$message.error(error.message || '操作失败') } finally { this.submitLoading = false }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.access-control-container {
  padding: 20px;

  .box-card { margin-bottom: 20px; }
  .el-pagination { margin-top: 20px; text-align: right; }

  .community-selector {
    max-height: 80vh; overflow-y: auto;
    .community-list { list-style: none; padding: 0; margin: 0; }
    .community-item {
      padding: 10px; cursor: pointer; transition: all 0.3s; color: #606060; font-size: 14px;
      &:hover { background-color: #f5f7fa; }
      &.selected { background-color: #409EFF; color: white; }
    }
  }

  .time-slot-card {
    display: flex; justify-content: space-between; align-items: center;
    padding: 10px 15px; border: 1px solid #e4e7ed; border-radius: 4px; cursor: pointer;
    transition: all 0.3s; background-color: #f5f7fa;
    &:hover { border-color: #409EFF; }
    .hours { font-size: 14px; font-weight: 500; }
    &.is-open { background-color: #f0f9eb; border-color: #67c23a; }
  }
}
</style>
